export { default } from './CategorySlider';
